import type { DashboardMetricsResponse } from '../../../types/dashboard';
import { mapArchMetricsData } from './mapArchMetricsData';
import type { ArchMetricsData } from './types';

export function mapApiToArchData(
  data: DashboardMetricsResponse | undefined
): ArchMetricsData | null {
  return mapArchMetricsData(data);
}
